import * as React from 'react';

import { ZoomOutButton } from './ZoomOutButton';
import { useMapContext } from '../../../context';
import { useTrackMapInteraction } from '../../../utils/useTrackMapInteraction';

export const ZoomOutButtonContainer: React.FC = props => {
  const { map } = useMapContext();
  const trackMapInteractions = useTrackMapInteraction();

  return <ZoomOutButton {...props} map={map} onClick={trackMapInteractions} />;
};
